import { useMemo } from "react";
import { ColumnsStrategy } from "../types";
import { cn } from "../utils";

export default function useGenerateColumns({
  strategy,
}: {
  strategy: ColumnsStrategy[];
}) {
  const columns = useMemo(() => {
    return strategy.map(
      ({ label, name, render, className, headerClassName, key }) => {
        return {
          key: name + key,
          dataIndex: name,
          title: label,
          className: className || "",
          render: render || ((value: any) => value),
          onHeaderCell: () => ({ className: cn(headerClassName) }),
        };
      }
    );
  }, [strategy]);

  return columns;
}
